import type { FC } from "react";

import { SelectItem, SelectWidget } from "@/ui-modules/core/forms/SelectWidget.js";

interface FileBrowserSortingWidgetsProps {
  sorting: string;
  setSorting: (sorting: string) => void;
}

export const FileBrowserSortingWidget: FC<FileBrowserSortingWidgetsProps> = (props) => {
  return (
    <SelectWidget
      icon={"sort"}
      label={"Sort by"}
      selectionMode={"single"}
      key={"sort-table-widget"}
      selectedKeys={[props.sorting]} // controlled selection
      onSelectionChange={(selection) => {
        // We need to trick a bit the Selection for the DataTable binding.
        // As we know this is a single selection, we can rely only on the Set values from the Selection type
        // and consider only the first one as there is only one anyways (single selection mode)
        if (selection instanceof Set) {
          props.setSorting(String([...selection][0] ?? undefined));
        }
      }}
    >
      <SelectItem key={"file.lastModified"}>Date Modified</SelectItem>
      <SelectItem key={"file.creator.display"}>Owner</SelectItem>
      <SelectItem key={"file"}>Name</SelectItem>
    </SelectWidget>
  );
};
